<template>
  <section class="headerArea" v-show="showTopBar">
    <div class="headerCenter clearfix">
      <span v-show="isLogin">工作不要太累，记得休息一下哟~</span>
      <div class="fr rightPart" v-show="isLogin">
        <a @click="toIndexPage" >首页</a>
        <a :href="centerLink">个人中心</a>
        <i>|</i>
        <span>你好，用户：{{userName}} <a class="outLine" @click="toLoginOutPage" >退出</a></span>
      </div>
      <div v-show="!isLogin" class="noSign fr">
        
        <span>
          你好，<a @click="toLoginInPage">请登录</a>  
          <a @click="toRegisterPage" >免费注册</a>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  props:['showTopBar'],
  data() {
    return {
      userName :'',
      isLogin:true,
      index_link:"",
      centerLink:'',//个人中心链接
      channel:'',//渠道Id
      login_link:''
    };
  },
  methods:{
    toIndexPage(){
      window.location.href = this.index_link
    },
    toLoginOutPage(){
      window.location.href = this.login_link+'passport-logout.html'
    },
    toLoginInPage(){
      window.location.href = this.login_link+'passport-logoff.html'
    },
    toRegisterPage(){
      window.location.href = this.login_link+'passport-jyfl_register.html'
    }
  },
  mounted(){
    this.userName = Cookies.get('movie-uname')
    this.channel = Cookies.get('channel')
    if(this.channel == 1){
      document.title = '电影'
      this.centerLink = global.config.personalCenterLinkB
      this.index_link = global.config.index_linkB
      this.login_link = global.config.login_linkB

    }else{
      document.title = '聚优电影'
      this.centerLink = global.config.personalCenterLinkA
      this.index_link = global.config.index_linkA
      this.login_link = global.config.login_linkA
    }

    decodeURI(this.userName)
    if(this.userName){
      this.isLogin = true
    }else{
      this.isLogin = false
    }
  }
};
</script>

<style lang="less" scoped>
a{
  cursor: pointer;
}
.headerArea{
  background: #333333;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #ffffff;
  .noSign{
    color: #fff;
    a{
      color: #fff;
    }
  }
  .outLine{
    color: #ffffff;
  }
  .headerCenter{
    width: 1200px;
    margin: 0 auto;
  }
  .rightPart{
    a{
      color: #ffffff;
      margin-left: 14px;
    }
    span{
      margin-left: 14px;
    }
    i{
      margin-left: 14px
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shares/centerHeader.vue